/**
 * VenueAvailabilityService
 * Read-only endpoint that runs the venue availability/conflict engine for a requested window +
 * party size without creating a booking — useful for UI pre-checks.
 * Route: api/venueavailability
 * Controller: VenueAvailabilityController.cs
 *
 * This is not a standard CRUD entity (single feature-check action), so it extends BaseService
 * directly rather than CrudService — mirrors ProjectSettingsService / MeetingSettingsService.
 */
import { BaseService } from '../base/BaseService';
export class VenueAvailabilityService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VenueAvailabilityService.DEFAULT_SERVICE_PATH,
            basePath: VenueAvailabilityService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Check whether a venue is free for a requested window + party size.
     * POST /api/venueavailability/check
     * @param request - Availability check request
     * @returns Availability result
     */
    async check(request) {
        const response = await this.checkRaw(request);
        if (!response.data) {
            throw new Error('Failed to check venue availability');
        }
        return response.data;
    }
    checkRaw(request) {
        const endpoint = this.getEndpoint('check', 'check');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, request);
    }
}
VenueAvailabilityService.DEFAULT_SERVICE_PATH = 'meetings';
VenueAvailabilityService.BASE_PATH = 'api/venueavailability';
//# sourceMappingURL=VenueAvailabilityService.js.map